<template>
  <div id='' v-loading='loading' style='' class='gPageBorder'>
    <el-form class='gForm' label-position="right" ref="firm" :rules='rules' label-width="18%" :model='firm'>
      <el-form-item :label="$t('app_psgname')" prop='name'>
        <el-input v-model="firm.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_distributor')" prop='mech'>
        <MechanismSelector style='' :data="mechanismData" ></MechanismSelector>
      </el-form-item>
      <el-form-item :label="$t('app_cbackad')" prop='callback'>
        <el-input v-model="firm.callback" placeholder=''></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_bsrqsadwl')" prop='addr'>
        <el-tag
					type='primary'
					:key="tag"
					v-for="tag in dynamicTags_ip"
					:closable="true"
					:close-transition="false"
					@close="handleCloseIP(tag)"
				>
				{{tag}}
				</el-tag>
				<el-input
					class="input-new-tag"
					v-if="inputVisible_ip"
					v-model="inputValue_ip"
					ref="saveTagInput_ip"
					size="mini"
					@keyup.enter.native="handleInputConfirmIP"
					@blur="handleInputConfirmIP"
				>
				</el-input>
				<el-button v-else class="button-new-tag" size="small" @click="showInputIP">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+{{$t('app_addaddr')}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
      </el-form-item>
			<el-form-item :label="$t('app_appwtls')" prop=''>
				<el-tag
					type='primary'
					:key="tag"
					v-for="tag in dynamicTags"
					:closable="true"
					:close-transition="false"
					@close="handleClose(tag)"
				>
				{{tag}}
				</el-tag>
				<el-input
					class="input-new-tag"
					v-if="inputVisible"
					v-model="inputValue"
					ref="saveTagInput"
					size="mini"
					@keyup.enter.native="handleInputConfirm"
					@blur="handleInputConfirm"
				>
				</el-input>
				<el-button v-else class="button-new-tag" size="small" @click="showInput">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+{{$t('app_addapppgkn')}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
      </el-form-item>
      <el-form-item :label="$t('app_authstat')" prop=''>
        <el-radio  class="radio" v-model="firm.authst" label="0">{{$t('app_open1')}}</el-radio>
				<el-radio  class="radio" v-model="firm.authst" label="1">{{$t('app_close')}}</el-radio>
      </el-form-item>
      <el-form-item>
        <el-button  type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
        <el-button  type='primary' style='' @click="save('firm')">{{$t('app_save')}}</el-button>
      </el-form-item>
    </el-form>
   
  </div>
</template>

<style>
</style>

<script>
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
		components: {
			MechanismSelector
		},
    data () {
      var phoneCheck = (rule, value, callback) => {
        if (!this.isLegalMobile(value)) {
          callback(new Error(this.$t('app_phoneIllegal')));
        } else {
          callback()
        }
			}
			var that = this
      return {
        loading: false,
        appid: '',
        detail: '',
				// fatherList: [],
				dynamicTags: [],
        inputVisible: false,
        inputValue: '',
        dynamicTags_ip: [],
        inputVisible_ip: false,
				inputValue_ip: '',
				mechanismData: "",
        firm: {
          name: '',
          mech: '',
          callback: '',
          authst: '0'
				},
				radioVl: '',
        rules: {
          name: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          callback: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          // tel: [
          //   { required: true, message: this.$t('app_inputTruePhone'), trigger: 'blur'/*, validator: phoneCheck*/}
          // ],
          mech: [
            { required: true, message: this.$t('app_select'), trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      getDetail () {
        this.loading = 1
        var _this = this
        this.$passageDetail(this.appid, (res) => { 
          this.loading = 0
          if (res.code === 200) {
            this.detail = res.data
            
            var data = res.data
            this.mechanismData = {
              value: data.merchantName,
              callback (value) {
                _this.firm.mech = value
              }
            }

            this.firm.name = data.appname
            this.firm.callback = data.callbackurl
            this.firm.mech = data.merchantid
            this.firm.authst = data.isauthen + ''
            this.dynamicTags = data.packageName?data.packageName:[]
            this.dynamicTags_ip = data.limitIp?data.limitIp:[]
            
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      handleCloseIP(tag) {
        this.dynamicTags_ip.splice(this.dynamicTags_ip.indexOf(tag), 1);
      },
      showInputIP() {
        this.inputVisible_ip = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput_ip.$refs.input.focus();
        });
      },
      handleInputConfirmIP() {
        let inputValue = this.inputValue_ip;
        if (inputValue) {
          this.dynamicTags_ip.push(inputValue);
        }
        this.inputVisible_ip = false;
        this.inputValue_ip = '';
      },
			handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      isLegalMobile (tel) {
        var sMobile = tel
        var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
        var re = new RegExp(regex, 'g') 
        if(!(re.test(sMobile))){
          return false
        } else {
          return true
        }
      },
      newfirm () {
				
        this.loading = 1
        
        var param = {
          "appName": this.firm.name,
          "isAuthen": this.firm.authst,
          "merchantId": this.firm.mech,
          "callbackUrl": this.firm.callback,
          "encryptType":"MD5", //加密类型 默认MD5
          "appownerType":"", //app调用属性
          "limitIp": this.dynamicTags_ip,
          "packageNames": this.dynamicTags
        }
        this.$addPassage(param, (res) => {
          this.loading = 0
          if (res.code === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      editfirm () {
        
        this.loading = 1
        var param = {
          "appId": this.appid,
          "appName": this.firm.name,
          "isAuthen": this.firm.authst,
          "merchantId": this.firm.mech,
          "callbackUrl": this.firm.callback,
          "encryptType":"MD5",
          "appownerType":"",
          "limitIp": this.dynamicTags_ip,
          "packageNames": this.dynamicTags
        }
        this.$editPassage(param, (res) => {
          this.loading = 0
          if (res.code === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
        }) 
      },
      save (name) {
				// console.log(this.firm)
			
				
			
        this.$refs[name].validate((valid) => {
          if (valid) {
            if (!this.appid) {
              this.newfirm()
            } else {
              this.editfirm()
            }
          } else {
            return false
          }
        })
      },
      cancel () {
        this.$router.go(-1)
      },
      fillData () {
        var _this = this
        var data = this.detail
        this.mechanismData = {
          placeholder: this.$t('lin_global.place_areaid'),
          value: data.merchantid,
          // optValue: true,
          callback (value) {
            _this.firm.mech = value
          }
        }

        this.firm.name = data.appname
        this.firm.callback = data.callbackurl
        this.firm.mech = data.merchantid
        this.firm.authst = data.isauthen + ''
        this.dynamicTags = data.packageName?data.packageName:[]
        this.dynamicTags_ip = data.limitIp?data.limitIp:[]
        
        
      }
    },
    mounted () {
			var appid = this.$getWObj().passageEdit
      if (appid) {
        this.appid = appid
        this.getDetail()
        
      } else {
        var _this = this
        this.mechanismData = {
          // value: '',
          callback (value) {
            _this.firm.mech = value
            // that.statusChange(value)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?4f13d36f